module.exports = __webpack_public_path__ + "static/media/restaurant.bc3b1320.jpg";